import React, { useState, useEffect } from "react";
import "react-sliding-pane/dist/react-sliding-pane.css";
import "jspdf-autotable";

import AllInvoiceReport from "./AllInvoiceReport";
import InvoiceswithDue from "./InvoiceswithDueReport";
import InvoiceAging from "./InvoiceAging";

function InvoiceReport({ id, setInvoiceview }) {
	const [loading, setLoading] = useState(false);
	const [viewInvoice, setviewInvoice] = useState("invoicewithdue");
	const [invoice, setInvoice] = useState(false);
	const [invoicewithdue, setInvoicewithdue] = useState(false);
	const [invoiceaging, setInvoiceaging] = useState(false)

	useEffect(() => {
		setLoading(false);
	}, []);

	useEffect(() => {
		setviewInvoice(setInvoiceview);
	}, [id, setInvoiceview]);


	useEffect(() => {
		viewInvoice === "invoice" ? setInvoice(true) : setInvoice(false);
		viewInvoice === "invoicewithdue"
		? setInvoicewithdue(true)
		: setInvoicewithdue(false);
		viewInvoice === "invoiceaging" ? setInvoiceaging(true): setInvoiceaging(false)
	}, [viewInvoice]);

	return (
		<>
			<div className="content container-fluid">
				<div value={viewInvoice} className="pt-1">
				</div>
				<div className="body py-2">
					<div className="col-md-12">
						{invoice && <AllInvoiceReport />}
						{invoicewithdue && <InvoiceswithDue />}
						{invoiceaging && <InvoiceAging/>}
					</div>
				</div>
			</div>
		</>
	);
}

export default InvoiceReport;
